import { create } from 'zustand';
import type { NotifyState } from './Notify.types';

export const useNotifyStore = create<NotifyState>((set) => ({
  value: null,
  show: (value: NotifyState['value']) => set({ value }),
  hide: () => set({ value: null }),
}));
